import React from 'react';
import {Grid, Typography} from '@mui/material';
import {PotDetails} from '../../../schema-types/PotDetails';

export const getSortCode = (currentAccount: PotDetails) => {
  const s = currentAccount?.sortCode;
  if (!s || s.length !== 6) {
    return 'N/A';
  }
  return `${s.substring(0, 2)}-${s.substring(2, 4)}-${s.substring(4)}`;
};

export const BuilderCurrentAccountDetails: React.FC<{currentAccount: PotDetails}> = ({
  currentAccount,
}) => {
  return (
    <Grid container direction="row" spacing={2}>
      <Grid item xs={3}>
        <Typography>Bank Name:</Typography>
        <Typography>
          <strong>{currentAccount?.productProvider?.formattedName}</strong>
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography>Account Name:</Typography>
        <Typography>
          <strong>{currentAccount?.contact?.simplifiedName || 'N/A'}</strong>
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography>Account Number:</Typography>
        <Typography>
          <strong>{currentAccount?.planNumber || 'N/A'}</strong>
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography>Sort Code:</Typography>
        <Typography className="sentry-mask">
          <strong>{getSortCode(currentAccount)}</strong>
        </Typography>
      </Grid>
    </Grid>
  );
};
